import { useState, useEffect, useRef } from "react";
import { MdNotifications } from "react-icons/md";
import {
  getNotifications,
  markAllAsRead,
} from "../../Services/notificationService";
import { notificationRoutes, NOTIFICATION_TEXT } from "./constants";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const popoverRef = useRef(null);
  const bellRef = useRef(null);

  const unreadCount = notifications.filter((n) => !n.is_read).length;

  const fetchNotifications = async () => {
    try {
      const res = await getNotifications();
      if(res.status === 200){
        setNotifications(res.data)
      } else {
        toast.error(NOTIFICATION_TEXT.FETCH_FAILED);
      }
      
    } catch (error) {
      toast.error(NOTIFICATION_TEXT.FETCH_ERROR);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        bellRef.current &&
        !bellRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleBellClick = () => setIsOpen((prev) => !prev);

  const handleMarkAllAsRead = async () => {
    try {
        const res = await markAllAsRead();
        if(res.status === 200 || res.status === 204){
            fetchNotifications();
        } else {
            toast.error(NOTIFICATION_TEXT.MARK_READ_FAILED);
        }
    } catch (error) {
      toast.error(NOTIFICATION_TEXT.MARK_READ_ERROR);
    }
  };

  const handleNotificationClick = (type) => {
    const route = notificationRoutes[type];
    if (route) {
      navigate(route);
      setIsOpen(false);
    }
  };

  const NotificationItem = ({ n }) => (
    <div
      onClick={() => handleNotificationClick(n.notification_type)}
      className={`rounded-md p-3 mb-2 border cursor-pointer transition-all duration-200 
                ${
                  n.is_read
                    ? "bg-gray-50 border-gray-200 text-gray-600"
                    : "bg-blue-50 border-blue-100 text-black font-medium hover:bg-blue-100"
                }`}
    >
      <p className="text-sm font-semibold mb-1">{n.message_title}</p>
      <p className="text-xs text-gray-700">{n.message}</p>
    </div>
  );

  const Popover = () => (
    <div
      ref={popoverRef}
      className={`z-[1000] shadow-lg border rounded-md max-h-[80vh] overflow-y-auto bg-white
            w-[90vw] sm:w-[24rem]
            fixed sm:absolute right-2 top-16 sm:right-0 sm:top-full sm:mt-2
        `}
    >
      <div className="flex items-center justify-between px-4 py-3 border-b bg-gray-100 sticky top-0 z-10">
        <h2 className="text-base font-semibold text-black">
          {NOTIFICATION_TEXT.HEADER}
        </h2>
        <button
          onClick={handleMarkAllAsRead}
          className="text-sm text-blue-600 hover:underline"
        >
          {NOTIFICATION_TEXT.MARK_ALL_AS_READ}
        </button>
      </div>
      <div className="p-3">
        {notifications.length === 0 ? (
          <p className="text-center text-gray-500 text-sm py-4">
            {NOTIFICATION_TEXT.NO_NOTIFICATIONS}
          </p>
        ) : (
          notifications.map((n) => <NotificationItem key={n.id} n={n} />)
        )}
      </div>
    </div>
  );

  return (
    <div className="relative inline-block">
      <button
        ref={bellRef}
        onClick={handleBellClick}
        className="relative focus:outline-none"
      >
        <MdNotifications size={24} className="text-white mx-0.5" />
        {unreadCount > 0 && (
          <span className="absolute -top-0 -right-0 bg-red-500 text-white text-[8px] px-[4px] rounded-full">
            {unreadCount}
          </span>
        )}
      </button>
      {isOpen && <Popover />}
    </div>
  );
};

export default NotificationBell;
